<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>
                            Cấu hình mapping báo cáo định kỳ/ đột xuất
                        </strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <b-row>
                            <b-col offset-md="3">
                                <b-form-group label="Nguồn báo cáo:"
                                              label-for="username"
                                              label-cols-md="2"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-col md="6 no-padding">
                                        <select2 placeholder="--- Chọn nguồn báo cáo ---"
                                                 v-if="listSyncDataSources.length > 0"
                                                 v-model="searchForm.syncDataSourceId"
                                                 :options="listSyncDataSources" allowClear>
                                        </select2>
                                    </b-col>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col offset-md="3">
                                <b-form-group label="Loại báo cáo:"
                                              label-for="unit"
                                              label-cols-md="2"
                                              :horizontal="true"
                                              label-align="left">
                                    <treeselect v-model="searchForm.reportTypeId"
                                                placeholder="--- Chọn loại báo cáo ---"
                                                :disable-branch-nodes="true"
                                                :show-count="true"
                                                class="col-md-6 no-padding"
                                                :options="listReports" />
                                </b-form-group>
                            </b-col>
                        </b-row>
                        
                        <b-row>
                            <b-col offset-md="3">
                                <b-form-group label="" :label-cols="4" label-cols-md="2">
                                    <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                    <br />
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            dataUrl="system-parameters/report-type-sync-data-sources"
                            gridName="Danh sách cấu hình mapping báo cáo định kỳ/ đột xuất"
                            ref="reportTypeSyncDataSourceTable">
                        <template v-slot:actions v-if="isAdmin">
                            <router-link to="./create" tag="button" class="btn btn-primary" size="md">
                                Thêm mới
                            </router-link>
                        </template>

                        <template v-slot:cell(reportTypeId)="row">
                            {{ $store.getters.getReportSyncTypeName(row.value) }}
                        </template>

                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <b-button size="sm" :to="{ path: `./${row.item.reportTypeId}/${row.item.syncDataSourceId}/detail` }" title="xem" variant="info">
                                    Xem
                                </b-button>
                                <template v-if="isAdmin">
                                    <b-button size="sm" :to="{ path: `./${row.item.reportTypeId}/${row.item.syncDataSourceId}/edit` }" title="sửa" variant="primary">
                                        Sửa
                                    </b-button>
                                    <b-button size="sm" @click.stop="remove(row.item, row.index, $event.target)" title="xóa" variant="danger">
                                        Xoá
                                    </b-button>
                                </template>
                            </b-button-group>
                        </template>
                    </b-grid>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { mixins } from '@/shared/mixins'
    import { validationMixin } from 'vuelidate'
    import { required, requiredIf, helpers, minValue } from 'vuelidate/lib/validators'

    const formatPattern = helpers.regex('formatPattern', /^((((\d+,)+\d+|(\d+(\/|-|#)\d+)|\d+L?|\*(\/\d+)?|L(-\d+)?|\?|[A-Z]{3}(-[A-Z]{3})?) ?){5})$/)

    //const formatPattern1 = helpers.regex('formatPattern1', /^(\*|(1?[0-9]|2[0-3])(-(1?[0-9]|2[0-3]))?)(\/[1-9][0-9]*)?(,(\*|(1?[0-9]|2[0-3])(-(1?[0-9]|2[0-3]))?)(\/[1-9][0-9]*)?)*$/)

    export default {
        name: 'CreateReportRequest',
        mixins: [mixins],
        data() {
            return {
                searchForm: {
                    syncDataSourceId: null,
                    reportTypeId: null
                },
                gridOptions: {
                    fields: [
                        { key: 'reportTypeId', label: 'Loại báo cáo', sortable: true },
                        { key: 'syncDataSourceName', label: 'Nguồn báo cáo', sortable: false },
                        { key: 'syncReportTypeCode', label: 'Mã báo cáo tương ứng của nguồn(PM) đồng bộ', sortable: false },
                    ],
                    sortBy: 'reportTypeId'
                },
            }
        },
        computed: {
            ...mapState({
                listReports: (state, getters) => getters.getTreeReportByReportType,
                listSyncDataSources: (state, getters) => getters.getSyncDataSources
            }),
        },
        created() {

        },
        watch: {
    
        },
        methods: {
            search() {
                this.$refs.reportTypeSyncDataSourceTable.refresh();
            },
            remove(item, index, button) {
                var vm = this;
                if (confirm('Bạn có chắc chắn muốn xóa cấu hình mapping báo cáo định kỳ/ đột xuất này?')) {
                    this.$services.delete(`system-parameters/report-type-sync-data-sources/${item.reportTypeId}/${item.syncDataSourceId}`).done(() => {
                        vm.$toastr.s('Xóa cấu hình mapping báo cáo định kỳ/ đột xuất thành công');
                        vm.search();
                    });
                }
            },
        }
    }

</script>
<style scoped>
</style>
